import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {VendorComponent} from '@shared/components/vendor/vendor.component';

@NgModule({
	imports: [CommonModule],
	declarations: [VendorComponent],
	exports: [VendorComponent],
})
export class VendorModule {}
